// src/Portfolio.js
import React from "react";
import Navbar from "./components/navbar/Navbar";
import Accueil from "./components/accueil/Accueil";
import Apropos from "./components/apropos/Apropos";
import Competences from "./components/competences/Competences";
import Realisations from "./components/realisations/Realisations";
import Contact from "./components/contact/Contact";
import Footer from "./components/footer/Footer";
import Carousel from "./components/carousel/Carousel";

const Portfolio = () => {
  return (
    <div>
      <Navbar />
      <Accueil />
      <Apropos />
      <Competences />
      <Carousel />
      <Realisations />
      <Contact />
      <Footer />
    </div>
  );
};

export default Portfolio;
